export const readCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
};

export const writeCookie = (name: string, value: string): void => {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/';
};
